export const versionInfo = {
  gitTag: 'v-1.1.1-140-g69186c9',
  tag: 'v-1.1.1',
  commitsAhead: '140',
  buildDate: 'Wed, 12 Aug 2026 09:39:18 GMT'
};
